module.exports = __webpack_public_path__ + "img/img14.572f0742.svg";